const contactCenterAction = action => {
    if (__CONTACT_CENTER__) {
        return action();
    }
}

const webappAction = action => {
    if (!__CONTACT_CENTER__) {
        return action();
    }
}

module.exports = {
    contactCenterAction,
    webappAction
};
